import { type ISegment } from "../../../../../interfaces";

export interface EmailDetailsProps {
  emailId: number;
}

export interface EmailDetailsState {
  isValid: boolean;
  activeStepIndex: EmailDetailsSteps;
  isDirty: boolean;
  isReverting: boolean;
  packsModalShown: boolean;
  selectedSends: { id: number; status: "canceled" | "scheduled" }[];
}

export interface PageInfo {
  index: number;
  segment: ISegment;
}

export enum EmailDetailsSteps {
  Performance,
  Configuration,
  Content,
  ScheduledSends,
  AssociatedPacks,
}

export enum EmailCreateSteps {
  Configuration,
  Content,
}

export const showLastModified = new Set([EmailDetailsSteps.Configuration, EmailDetailsSteps.Content]);
export const showReportLastUpdated = new Set([EmailDetailsSteps.Performance]);
